/**
 * DocViewSchema for Storefront Page Config DocType
 * 
 * Single section with the page builder widget.
 */

import type { DocViewSchema } from "./types";

export const storefrontPageConfigDocViewSchema: DocViewSchema = {
  doctype: "Storefront Page Config",
  views: {
    experience: {
      style: "shopify",
      sections: [
        {
          id: "page-builder",
          label: "Page Builder",
          description: "Edit page sections and SEO",
          widgetId: "StorefrontPageBuilderWidget",
        },
      ],
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["page-builder"],
        },
      ],
      quickActions: [],
      connectionGroups: [],
    },
  },
};
